import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">      
        <h1 className="text-center display-4 fw-bold mb-5 text-light">About Us</h1>    
        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Our Mission</h2>
              <p className="text-primary mb-4">
              <p>
                At Klassi, our mission is to empower organizations to thrive in the digital age by delivering intelligent, future-ready software solutions. We are driven by a passion for innovation and a commitment to excellence—combining the latest advancements in technology with deep business insight to solve complex challenges and unlock new opportunities.</p>
              <p>
                We believe that digital transformation is more than just adopting new tools—it's about reimagining how businesses operate, compete, and grow. That’s why we partner closely with our clients to understand their unique goals and craft tailored solutions that are scalable, secure, and strategically aligned with their vision. </p>
              <p>
                From streamlining operations and enhancing customer experiences to enabling data-driven decision-making and fostering innovation, Klassi is dedicated to building software that delivers measurable impact and long-term value. </p>
              <p>
                We don’t just write code—we architect digital ecosystems that drive progress, resilience, and sustainable success.</p>
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Our Vision</h2>
              <p className="text-primary mb-4">
                <p>
                At Klassi, we envision a future where technology is not just a tool, but a seamless extension of every business process—empowering organizations to operate with greater agility, intelligence, and impact. We see a world where digital innovation drives meaningful change, enabling businesses of all sizes to unlock their full potential and deliver exceptional value to their customers.</p>
                <p>
                Our vision is to be a catalyst in this transformation—leading the way with forward-thinking solutions that bridge the gap between complex technology and practical business needs. Through our unwavering commitment to excellence, creativity, and continuous improvement, we aim to shape the future of digital innovation and become a trusted partner for organizations navigating the evolving digital landscape.</p>
                <p>
                  At Klassi, we don’t just anticipate the future—we help build it.</p>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About; 